import { Base } from '@studiometa/js-toolkit';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
import { SplitText } from 'gsap/SplitText.js';

gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrollTrigger);

/**
 * FillingText component
 */
export default class FillingText extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'FillingText',
    refs: ['title', 'images[]'],
  };

  /**
   *
   */
  mounted() {
    const splitTitle = SplitText.create(this.$refs.title, { type: 'chars' });
    const imageWidth = gsap.getProperty(this.$refs.images[0], 'width');

    gsap.set(this.$refs.images, { width: 0, opacity: 1 });

    gsap.to(splitTitle.chars, {
      color: '#000',
      stagger: 0.08,
      ease: 'power4.out',
      scrollTrigger: {
        trigger: this.$el,
        start: 'top top',
        end: 'center top',
        scrub: true,
        pin: false,
        markers: false,
      },
    });

    this.$refs.images.forEach((element) => {
      gsap.to(element, {
        width: imageWidth,
        duration: 0.8,
        ease: 'power4.out',
        scrollTrigger: {
          trigger: element,
          start: '-500px',
          end: '-200px',
          scrub: true,
        },
      });
    });
  }
}
